import { Component, inject } from '@angular/core';
import { getMenuItemsList, menuItemsListForSecurity } from '../../definitions/menu-items-list';
import { ImpersonateModalComponent } from './impersonate-modal/impersonate-modal.component';
import { MainTitle } from '../../models/main-title';
import { MatDialog } from '@angular/material/dialog';
import { MenuItemInterface } from 'src/interfaces/menu.interface';
import { Router } from '@angular/router';
import { allSecurityDomains } from '../main/main.component';
import { getStorageObject } from '../../utils/storage-manager';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  private router = inject(Router);
  private dialogService = inject(MatDialog);

  public title = new MainTitle(getStorageObject('vertical').name);

  protected menuItems: MenuItemInterface[] =
    allSecurityDomains.includes(getStorageObject('vertical').domain) ?
      menuItemsListForSecurity : getMenuItemsList(getStorageObject('userData').roles);

  protected readonly getStorageObject = getStorageObject;
  protected readonly securityDomains = allSecurityDomains;

  onMenuItemClick(path: string): void {
    if (path === '/impersonate') {
      this.openImpersonateModal();
    } else {
      this.router.navigateByUrl(path);
    }
  }

  openImpersonateModal(): void {
    this.dialogService.open(ImpersonateModalComponent, {
      width: '33.6rem'
    });
  }

  protected readonly allSecurityDomains = allSecurityDomains;
}
